export const OVERLAY_CLASSNAME = '.common-overlay';

export const TRACKING_EVENTS = {
  buttonClick: 'Button Click',
  pageView: 'Page View',
};
